import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { of } from "rxjs";
import { catchError } from "rxjs/operators";
import { GlobalService } from "src/app/global.service";
import { HttpService } from "src/app/http.service";

@Component({
  selector: "app-icustomer-confirm-order",
  templateUrl: "./icustomer-confirm-order.component.html",
  styleUrls: ["./icustomer-confirm-order.component.scss"],
})
export class IcustomerConfirmOrderComponent implements OnInit {
  business_details: any;
  order_details: any;
  order_amount: any;
  is_wallet_selected = true;
  final_customer_wallet: any = 0;
  final_price_after_wallet: any;
  wallet_balance: any;
  disable_button = false;
  final_price: any;

  constructor(
    public dialogRef: MatDialogRef<IcustomerConfirmOrderComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private http: HttpService,
    private global: GlobalService
  ) {
    // console.log(this.confirm_button);
    console.log(data);
    this.order_details = data;
    this.wallet_balance = this.order_details["wallet_balance"];
    this.order_amount =
      this.order_details["product_form_data"]["total_price_per_order"];
    this.final_price =
      this.order_details["product_form_data"]["total_price_per_order"];
    if (this.wallet_balance > 0) {
      this.final_price = this.order_amount - this.wallet_balance;
      this.final_customer_wallet = this.wallet_balance - this.order_amount;
      if (this.final_customer_wallet <= 0) {
        this.final_customer_wallet = 0;
      }
      if (this.final_price <= 0) {
        this.final_price = 0;
      }
    } else {
      this.final_price = this.order_amount;
      this.is_wallet_selected = false;
    }
  }

  walletCheckboxChanged(event) {
    if (!event.checked) {
      this.final_price = this.order_amount;
      this.final_customer_wallet = this.wallet_balance;
    } else {
      this.final_customer_wallet = this.wallet_balance - this.final_price;
      this.final_price -= this.wallet_balance;
      if (this.final_price <= 0) {
        this.final_price = 0;
      }
      if (this.final_customer_wallet <= 0) {
        this.final_customer_wallet = 0;
      }
    }
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }

  async payClicked() {
    // this.order_details['product_form_data']['total_price_per_order'] = this.final_price;
    let data_dict = this.order_details;
    data_dict["from"] = "portal";
    data_dict["final_customer_wallet"] = this.final_customer_wallet;
    data_dict["final_price"] = this.final_price;
    data_dict["order_amount"] = this.order_amount;
    this.disable_button = true;
    console.log(data_dict);

    this.http
      .registerOrderForICustomer(data_dict)
      .pipe(
        catchError((error) => {
          if (error.status === 400) {
            alert(error["error"]["message"]);
          }
          console.error("Bad Request", error);
          this.disable_button = false;
          let return_data = {
            is_compleated: false,
          };
          this.closeComponent(return_data);
          // Return an empty observable to keep the stream alive
          throw error;
        })
      )
      .subscribe(
        (data) => {
          console.info(data);
          this.disable_button = false;
          let return_data = {
            is_compleated: true,
            data: data,
          };
          this.closeComponent(return_data);
        },
        // (error) => {
        //   alert("Error While ordering");
        //   this.disable_button = false;
        //   let return_data = {
        //     is_compleated: false,
        //   };
        //   this.closeComponent(return_data);
        //   console.error(error);
        // }
      );
  }

  ngOnInit() {}
}
